import { __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';

var styledIf = function (cond, primaryQuery, secondaryQuery) {
    return !secondaryQuery ? (cond ? primaryQuery : "") : cond ? primaryQuery : secondaryQuery;
};
var withAttrs = function (Component, attrs) { return function (props) { return React__default.createElement(Component, __assign({}, attrs, props)); }; };

export { styledIf, withAttrs };
